module.exports = __webpack_public_path__ + "img/thor.cbf58618.jpg";